import { Box, Typography } from "@mui/material";
import React from "react";
import RatingComponent from "../../components/RatingComponent";
import TextAreaComponent from "../../components/Input/TextAreaComponent";
import { setAddFields } from "../../store/slice/feedback.slice";

const QuestionAnswerComponent = ({data,name,Css}) => {
  return (
  
      <Box
        sx={{
          width: {xs:"100%"},
          height: "100%",
          borderRadius: "10px",
          border: `1px solid ${Css?.QuestionCardBorderClr}`,
          backgroundColor: Css?.QuestionCardBgClr,
          p:2,
          mt:2,
          pb:3
          

        }}
      >
        <Box>
        <Typography sx={{color:Css?.QuestionClr,fontSize:{md:"20px",sm:"16px",xs:"14px"},fontWeight:"medium"}}>{data?.name}</Typography>
        <Typography sx={{color:Css?.feedbackInfoClr,fontSize:{md:"16px",sm:"14px",xs:"12px"},fontWeight:"regular",mt:1}}>
        {data?.info}
        </Typography>
        </Box>
        <Box>
            <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <RatingComponent data={data} name={data?.name?.replace(/\s+/g, '')} setField={setAddFields} Css={Css}/>
             
            </Box>
        <Box>
        </Box>
  
      </Box>
    </Box>
    
  );
};

export default QuestionAnswerComponent;
